import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useCookieConsent } from '../CookieConsentProvider';

export function CookieBanner() {
  const { t } = useTranslation('cookies');
  const { acceptAll, declineAll, openPreferences } = useCookieConsent();
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(false);
  const policyUrl = import.meta.env.VITE_PRIVACY_POLICY_URL || '/cookie-policy';

  if (dismissed || pathname === '/cookie-policy') return null;

  return (
    <section
      role="region"
      aria-label={t('banner.message')}
      className="fixed inset-x-0 bottom-0 z-40 w-full bg-white border-t border-gray-200 shadow-lg px-4 py-4 sm:px-6"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-sm text-gray-700 flex-1">
          {t('banner.message')}{' '}
          <a
            href={policyUrl}
            onClick={() => setDismissed(true)}
            className="text-[color:var(--color-primary)] underline"
          >
            {t('banner.policyLink')}
          </a>
        </p>
        <div className="flex flex-wrap gap-2 shrink-0">
          <button
            type="button"
            onClick={declineAll}
            className="px-3 py-1.5 text-sm text-gray-600 border border-gray-300 rounded hover:bg-gray-50 transition-colors"
          >
            {t('banner.declineAll')}
          </button>
          <button
            type="button"
            onClick={openPreferences}
            className="px-3 py-1.5 text-sm text-gray-600 border border-gray-300 rounded hover:bg-gray-50 transition-colors"
          >
            {t('banner.managePreferences')}
          </button>
          <button
            type="button"
            onClick={acceptAll}
            className="px-3 py-1.5 text-sm text-white bg-green-600 rounded hover:bg-green-700 transition-colors"
          >
            {t('banner.acceptAll')}
          </button>
        </div>
      </div>
    </section>
  );
}
